<section class="tw-py-12 tw-px-4 tw-bg-[#F7F7F7]">
    <div
        class="tw-flex tw-flex-col tw-items-center tw-max-w-[990px] tw-mx-auto tw-gap-4"
    >
        <h2
            class="!tw-text-[30px] tw-text-[#0F3172] !tw-font-bold !tw-text-center"
        >
            {{ "FINANCING_CALCULATOR.BENEFITS" | translate }}
        </h2>
        <p class="!tw-text-[14px] tw-text-[#1A202C] !tw-text-center">
            {{ "FINANCING_CALCULATOR.BENEFITS_DESC" | translate }}
        </p>
        <p class="!tw-text-[14px] tw-text-[#1A202C] !tw-text-center">
            {{ "FINANCING_CALCULATOR.LIST_NOTE" | translate }}
        </p>

        <div class="tw-w-full tw-my-6">
            <!-- Desktop Grid -->
            <div
                *ngIf="!isMobile"
                class="tw-max-w-[920px] tw-grid tw-grid-cols-3 tw-gap-4 tw-mx-auto tw-relative"
            >
                <div
                    class="tw-absolute tw-w-[70%] tw-h-[3px] tw-bg-blue-600 tw-top-[90px] tw-left-[50%] tw-translate-x-[-50%]"
                ></div>
                <div
                    class="tw-flex tw-flex-col tw-items-center tw-max-w-[250px] tw-mx-auto tw-gap-2 !tw-text-center"
                    *ngFor="let item of benefitsData; let i = index"
                >
                    <span class="!tw-font-bold !tw-text-[20px]"
                        >{{ "FINANCING_CALCULATOR.STEP" | translate }}
                        {{ i + 1 }}</span
                    >
                    <img
                        class="tw-h-[115px] tw-bg-[#F7F7F7] tw-rounded-full tw-relative"
                        [src]="item.img"
                        [alt]="item.title"
                    />

                    <h4 class="!tw-font-bold !tw-text-[20px]">
                        {{
                            selectedLanguage === "en"
                                ? item.title
                                : item.titleBm
                        }}
                    </h4>
                    <p class="!tw-text-[#666666] !tw-text-[18px]">
                        {{
                            selectedLanguage === "en" ? item.desc : item.descBm
                        }}
                    </p>
                </div>
            </div>

            <!-- Mobile Carousel Version -->
            <div *ngIf="isMobile" class="tw-w-full">
                <div class="tw-relative tw-overflow-hidden tw-pt-[30px]">
                    <div
                        *ngFor="let item of benefitsData; let i = index"
                        [@slideAnimation]="getSlideState(i)"
                        [style.display]="i === activeIndex ? 'block' : 'none'"
                        class="tw-w-full"
                    >
                        <div
                            [ngClass]="
                                i === 0
                                    ? 'tw-right-[0] tw-w-[48%]'
                                    : i === 1
                                    ? '  tw-left-[50%] tw-translate-x-[-50%] tw-w-[100%]'
                                    : i === 2
                                    ? 'tw-left-[0] tw-w-[48%]'
                                    : ''
                            "
                            class="tw-absolute mb-slid tw-h-[3px] tw-bg-blue-600 tw-top-[-18px]"
                        ></div>
                        <div
                            class="tw-px-4 tw-pb-8 tw-text-center tw-flex tw-flex-col tw-gap-2"
                            style="min-height: 250px"
                        >
                            <img
                                class="tw-h-[115px] tw-w-[115px] tw-bg-[#F7F7F7] tw-rounded-full tw-mx-auto tw-relative"
                                [src]="item.img"
                                [alt]="
                                    selectedLanguage === 'en'
                                        ? item.title
                                        : item.titleBm
                                "
                            />
                            <span class="!tw-font-bold !tw-text-[20px]"
                                >{{ "FINANCING_CALCULATOR.STEP" | translate }}
                                {{ i + 1 }}</span
                            >
                            <h4 class="!tw-font-bold tw-mt-4">
                                {{
                                    selectedLanguage === "en"
                                        ? item.title
                                        : item.titleBm
                                }}
                            </h4>
                            <p class="!tw-text-[#666666]">
                                {{
                                    selectedLanguage === "en"
                                        ? item.desc
                                        : item.descBm
                                }}
                            </p>
                        </div>
                    </div>

                    <!-- Dot Indicators -->
                    <div class="tw-flex tw-justify-center tw-gap-2 tw-mt-2">
                        <button
                            *ngFor="let i of benefitsData; let idx = index"
                            (click)="setActiveIndex(idx)"
                            [ngClass]="{
                                'tw-bg-[#BDBDBD]': activeIndex === idx,
                                'tw-bg-gray-200': activeIndex !== idx
                            }"
                            class="tw-w-2 tw-h-2 tw-rounded-full"
                        ></button>
                    </div>
                </div>
            </div>
        </div>

        <span class="!tw-text-[14px] tw-text-[#1A202C] !tw-text-center">
            {{ "FINANCING_CALCULATOR.BENEFITS_NOTE" | translate }}</span
        >
    </div>
</section>
